import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=77b11c8a&scoped=true"
import script from "./shopList.vue?vue&type=script&lang=js"
export * from "./shopList.vue?vue&type=script&lang=js"
import style0 from "./shopList.vue?vue&type=style&index=0&id=77b11c8a&prod&scoped=true&lang=css"
import style1 from "./shopList.vue?vue&type=style&index=1&id=77b11c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b11c8a",
  null
  
)

export default component.exports